import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'

export const RecaptchaVerificationError = () => {
  const { t } = useTranslation()

  return (
    <Box flexCol gapY={16} aria-label="recaptcha verification error">
      <p className="text-body-regular" color="inherit">
        {t('recaptcha.verificationFailed')}
      </p>
      <p className="text-body-regular" color="inherit">
        {t('recaptcha.verificationError.description')}
      </p>
      <ul className="text-body-regular list-disc pl-6" color="inherit">
        <li>{t('recaptcha.verificationError.internetConnection')}</li>
        <li>{t('recaptcha.verificationError.vpnOrProxy')}</li>
        <li>{t('recaptcha.verificationError.domainBlocked')}</li>
      </ul>
    </Box>
  )
}
